export const APP_NAME = 'EZROI'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const secretkey = 'secretkeyIV'